import { render, staticRenderFns } from "./LeadlikeDetails.vue?vue&type=template&id=8c7c1c7a&scoped=true&"
import script from "./LeadlikeDetails.vue?vue&type=script&lang=js&"
export * from "./LeadlikeDetails.vue?vue&type=script&lang=js&"
import style0 from "./LeadlikeDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LeadlikeDetails.vue?vue&type=style&index=1&id=8c7c1c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7c1c7a",
  null
  
)

export default component.exports